/* eslint-disable indent */
'use client';
import { useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { EpDatepicker } from '../../../components/EpDatepicker';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { EpStepContent } from '../components';
import { EpErrorMessage } from '../components/EpErrorMessage';
export default function PatientBirthDate({
  translations,
  isPharmacy = false,
}: {
  translations: string[];
  isPharmacy?: boolean;
}) {
  const { setValue, register, control, getValues } = useFormContext();
  const { i18n } = useTranslation();
  const [visible, setVisible] = useState(false);
  const activeStep = useWatch({ name: 'formUtils.activeStep' });
  const PersonValue = useWatch({ name: 'person.inputValue' });

  const NoId = useWatch({ name: 'noId' });
  const personType = useWatch({ name: 'personType' });
  const checkIfIsPersonValid =
    (PersonValue === 'true' || PersonValue === undefined) && !!NoId;
  const checkIfIsPersonType =
    personType?.inputValue && personType?.inputValue !== '1';
  const isVisible = checkIfIsPersonValid || checkIfIsPersonType || isPharmacy;

  const NotificationIntubationDateId = useWatch({
    name: 'notificationIntubationDateId',
  });
  const PatientBirthDate = useWatch({ name: 'patientBirthDate' });

  register('patientBirthDateIsValid', {
    required: t(
      translations,
      'Birth Date cannot be greater than the Incident Date.',
    ),
  });

  useEffect(() => {
    if (NotificationIntubationDateId) {
      const incidentDate = new Date(`${NotificationIntubationDateId} 00:00`);
      const birthDate = new Date(PatientBirthDate);
      if (incidentDate < birthDate) {
        setValue('patientBirthDateIsValid', undefined);
      } else {
        setValue('patientBirthDateIsValid', true);
      }
    } else {
      setValue('patientBirthDateIsValid', true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [NotificationIntubationDateId]);

  useEffect(() => {
    if (personType && activeStep === '1') {
      setValue('patientBirthDate', undefined);
    }
  }, [activeStep, personType, setValue]);

  useEffect(() => {
    setVisible(isVisible);
  }, [isVisible]);

  if (!visible) return null;

  return (
    <>
      {visible && (
        <EpStepContent.Label label={t(translations, 'Birth date:')}>
          <Controller
            name={'patientBirthDate'}
            control={control}
            rules={{
              required: {
                value: false,
                message: t(translations, '* Required Fied'),
              },
            }}
            render={({ field }) => (
              <EpDatepicker
                datepickerId={'patientBirthDate'}
                cultureCode={i18n.language}
                datepickerInputName={field.name}
                reactHookFormGetValues={getValues}
                reactHookFormValue={
                  field.value
                    ? typeof field.value === 'string'
                      ? field.value
                      : new Intl.DateTimeFormat(i18n.language).format(
                          new Date(field.value),
                        )
                    : ''
                }
                datepickerMaxDate={new Date()}
                reactHookFormOnChangeFunc={field.onChange}
                inputHasIcon={true}
                isoFormatDate
              />
            )}
          />
          <EpErrorMessage inputName="patientBirthDate" />
          <EpErrorMessage inputName="patientBirthDateIsValid" />
        </EpStepContent.Label>
      )}
    </>
  );
}
